import { signOut } from 'aws-amplify/auth';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const UserMenu = ({ isAuthenticated, sandboxSignInUrl }) => {
  const navigate = useNavigate();
  const { authenticateUser } = useAuth();

  async function handleSignOut() {
    try {
      await signOut();
      authenticateUser(false, '', '');
      localStorage.setItem('isAuthenticated', false);
      navigate('/');
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  return (
    <>
      {isAuthenticated ? (
        <>
          <a className="user-menu-item" href="/preferences">
            Preferences
          </a>
          <a className="user-menu-item" href="/certificates">
            My certificates
          </a>
          {sandboxSignInUrl && (
            <a href={sandboxSignInUrl} className="user-menu-item" target="_blank" rel="noopener noreferrer">
              AWS Sandbox
            </a>
          )}
          <button onClick={handleSignOut} className="user-menu-item">
            Sign out
          </button>
        </>
      ) : (
        <a className="user-menu-item" href="/signin">
          Sign in
        </a>
      )}
    </>
  );
};

export default UserMenu;
